import { LightningElement, track, api, swapTemplate } from 'lwc';
import '@lwc/synthetic-shadow';


const VARIANTS = [
    'framed-pool',
];

export default class customSvgs extends LightningElement {
    

    _isFramedPool = false;
    _isFullPool = false
    _isHotTub = false;
    _isColdPlunge = false;
    _isLogo = false;
    _isGuests = false;
    _isTest1 = false;
    _isTest2 = false;
    _isTest3 = false;
    _isTest4=false;


    @api width = "34px";
    @api height = "34px";

    get logoWidth() {
        const numStr = this.height.replace('px', '');
        const num = Number(numStr);
        if (!isNaN(num) && isFinite(num)) {
            return `${num * 2.75}px`;
        }
    }

    @api 
    set fill(value) {
        this._fill = value;
    } 
    get fill() {
        return this._fill ?? '#747474';
    }

    @api 
    set variant(val) {
        this.handleVariant(val);
        this._variant = val;
    }
    get variant() {
        return this._variant;
    }

    handleVariant(val) {
        this._isFramedPool = val === 'framed-pool';
        this._isFullPool = val === 'full-pool';
        this._isHotTub = val === 'hot-tub';
        this._isColdPlunge = val === 'cold-plunge'; 
        this._isLogo = val === 'logo';
        this._isGuests = val === 'guests';
        this._isTest1 = val === 'isTest1';
        this._isTest2 = val === 'isTest2';
        this._isTest3 = val === 'isTest3';
        this._isTest4 = val === 'isTest4';
    }


    // Apply Styles to the host 👉 Can pass 1.Array of Arrays   2.Array of Object   3.Strings
    _applyVarsDirect(cssVar, varStyle=null) {

        // Check that CSS var starts with '--' and has a non-null stlye 
        const isValid = (cssVarP, varStyleP) => {
            return typeof cssVarP === 'string' && 
                typeof varStyleP === 'string' &&
                cssVarP?.startsWith('--') && 
                varStyleP;
        }


        if (Array.isArray(cssVar)) {
            // Handle Array of vars
            cssVar.forEach(hostVar => {
                if (Array.isArray(hostVar) && isValid(hostVar[0], hostVar[1])) {
                    // Handle Array structure  (CSS var at index 0)
                    this.style.setProperty(hostVar[0], hostVar[1]);
                } else if (typeof hostVar === 'object' && isValid(hostVar.cssVar, hostVar.varStyle)) {
                    // Handle Object structure (cssVar & varStyle keys)
                    this.style.setProperty(hostVar.cssVar, hostVar.varStyle)
                }
            });
        } else if (isValid(cssVar, varStyle)) {
            // Handle string arguments
            this.style.setProperty(cssVar,  varStyle);
        }
    }

}